// Timings.jsx
import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import backgroundImage from './namaz.png';
import './Timings.css';

const IslamicMonths = [
  'Muḥarram',
  'Ṣafar',
  'Rabīʿ al-Awwal',
  'Rabīʿ al-Thānī',
  'Jumādā al-Awwal',
  'Jumādā al-Thānī',
  'Rajab',
  'Shaʿbān',
  'Ramaḍān',
  'Shawwāl',
  'Dhū al-Qaʿdah',
  'Dhū al-Ḥijjah',
];

const Timings = () => {
  const [prayerTimings, setPrayerTimings] = useState({});
  const [showAllTimings, setShowAllTimings] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [currentDate, setCurrentDate] = useState('');
  const [islamicDate, setIslamicDate] = useState('');

  useEffect(() => {
    const fetchNamazTimings = async () => {
      try {
        const response = await fetch('https://api.aladhan.com/v1/timingsByCity?city=Lahore&country=Pakistan&method=1');

        if (response.ok) {
          const data = await response.json();
          setPrayerTimings(data.data.timings);
        } else {
          console.error('Failed to fetch Namaz timings:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching Namaz timings:', error.message);
      }
    };
    const fetchIslamicDate = async () => {
      try {
        const response = await fetch('https://api.aladhan.com/v1/gToH');
        
        if (response.ok) {
          const data = await response.json();
          console.log('Islamic Date API Response:', data);
    
          if (data.data && data.data.hijri && data.data.hijri.date) {
            const hijriDate = data.data.hijri.date;
            setIslamicDate(hijriDate);
          } else {
            console.error('Invalid Islamic date data structure:', data);
            setIslamicDate('N/A');
          }
        } else {
          console.error('Failed to fetch Islamic date:', response.statusText);
          setIslamicDate('N/A');
        }
      } catch (error) {
        console.error('Error fetching Islamic date:', error.message);
        setIslamicDate('N/A');
      }
    };
    

    fetchNamazTimings();
    fetchIslamicDate();
  }, [currentTime]); // Run the effect whenever currentTime changes

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      setCurrentTime(now);
      setCurrentDate(now.toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric' }));
    };

    const intervalId = setInterval(updateDateTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const handleCardClick = () => {
    setShowAllTimings(!showAllTimings);
  };

  const getUpcomingPrayer = () => {
    const currentHour = currentTime.getHours();
    let upcomingPrayer = '';

    for (const prayer in prayerTimings) {
      const prayerHour = parseInt(prayerTimings[prayer].split(':')[0], 10);

      if (prayerHour > currentHour) {
        upcomingPrayer = `${prayer}: ${prayerTimings[prayer]}`;
        break;
      }
    }

    return upcomingPrayer || 'All prayers for today have passed.';
  };

  return (
    <div className="timings-container">
      <Card className="card" style={{ backgroundColor: 'darkslategrey', color: 'white', borderRadius: '7px' }} onClick={handleCardClick}>
        <img src={backgroundImage} alt='' />
        <CardContent className="cardContent">
          <Typography variant="h3" gutterBottom style={{ fontFamily: 'Cinzel Decorative', fontSize: '2.5rem', fontWeight: 'bolder', color: 'gold' }}>
            Namaz Timings
          </Typography>
          {showAllTimings ? (
            <ul>
              {Object.entries(prayerTimings).map(([name, time]) => (
                <li key={name}>
                  {name}: {time}
                </li>
              ))}
            </ul>
          ) : (
            <Typography variant="body3" paragraph>
              <strong> Namaz = </strong> {getUpcomingPrayer()}
            </Typography>
          )}
          <Typography variant="body3" paragraph>
            <strong>Click to show all</strong>
          </Typography>
          <Typography variant="h5" style={{ fontFamily: 'OpenSans', color: 'goldenrod' }}>
            "The prayer of a sincere heart is heard and accepted by Allah." - Unknown
          </Typography>
        </CardContent>
      </Card>

      {/* Second Section */}
      <Card className="card second-card" style={{ backgroundColor: 'darkslategray', color: 'slateblue', borderRadius: '7px' }}>
      <img src={backgroundImage} alt='' />
        <CardContent className="cardContent" style={{marginTop:'10px'}}>
        <Typography variant="h3" gutterBottom style={{ fontFamily: 'Cinzel Decorative', fontSize: '2.5rem', fontWeight: 'bolder', color: 'gold' }}>
            Date-&-Time
          </Typography>
          <Typography variant="h5" style={{ fontFamily: 'Cinzel Decorative', color: 'goldenrod' }}>
           <p style={{color:'white',fontWeight:'lighter',fontFamily:'Open Sans', fontStyle:'italic'}}> <strong style={{color:'goldenrod'}}> Current Time: </strong>{currentTime.toLocaleTimeString()} </p>
          </Typography>
          <Typography variant="h5" style={{ fontFamily: 'Cinzel Decorative', color: 'goldenrod' }}>
           <p style={{color:'white',fontWeight:'lighter',fontFamily:'Open Sans', fontStyle:'italic'}}> <strong style={{color:'goldenrod'}}> Date:</strong>{currentDate} </p>
          </Typography> 
          <Typography variant="h5" style={{ fontFamily: 'Cinzel Decorative', color: 'goldenrod' }}>
            <p style={{color:'white',fontWeight:'lighter',fontFamily:'Open Sans', fontStyle:'italic'}}> <strong style={{color:'goldenrod'}}> Islamic Date:</strong> {`${islamicDate.split('-')[0]} - ${IslamicMonths[parseInt(islamicDate.split('-')[1], 10) - 1]} - ${islamicDate.split('-')[2]} Hijri`} </p>
          </Typography>
          {/* Additional content for the second section */}
        </CardContent>
      </Card>
    </div>
  );
};

export default Timings;                                                                                                                                                                        